/* Opgeslagen zoekopdrachten — inklapbare kaartenrij boven de kandidatenlijst. */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { Bookmark, Calendar, ChevronDown, ChevronRight, Sparkles, Trash2 } from "lucide-react";

export default function SavedSearchesSection({ searches, activeId, onPick, onDelete }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(true);
    return (
        <div className="mb-4 rounded-xl border border-white/10 bg-[var(--jr-surface)]" data-testid="saved-searches-section">
            <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-4 py-3 hover:bg-white/[0.02]">
                <div className="flex items-center gap-2">
                    <Bookmark size={13} className="text-[var(--jr-amber)]" />
                    <span className="text-[10px] font-mono uppercase tracking-[0.22em] text-[var(--jr-text-3)]">{t("search.saved_searches_title")}</span>
                    <span className="text-[10px] font-mono text-[var(--jr-text-3)]">· {searches.length}</span>
                </div>
                {open ? <ChevronDown size={14} className="text-[var(--jr-text-3)]"/> : <ChevronRight size={14} className="text-[var(--jr-text-3)]"/>}
            </button>
            {open && (
                <div className="px-3 pb-3 flex gap-2 overflow-x-auto">
                    {searches.map((s) => {
                        const isActive = activeId === s.id;
                        return (
                            <div key={s.id} data-testid={`saved-search-${s.id}`}
                                className={`shrink-0 w-72 rounded-lg border p-3 transition-colors ${isActive ? "border-[var(--jr-amber)] bg-[var(--jr-amber)]/8" : "border-white/10 bg-[var(--jr-surface-2)] hover:border-white/20"}`}>
                                <button onClick={() => onPick(s.id)} className="text-left w-full min-w-0" data-testid={`saved-search-open-${s.id}`}>
                                    <div className="text-sm font-medium text-white truncate">{s.label}</div>
                                    <div className="text-[10px] text-[var(--jr-text-3)] font-mono mt-1 flex items-center gap-2 flex-wrap">
                                        <span className="inline-flex items-center gap-1"><Calendar size={9}/> {(s.created_at || "").slice(0, 10)}</span>
                                        <span>· via {s.source}</span>
                                        <span>· {(s.candidate_ids || []).length} kandidaten</span>
                                    </div>
                                    {s.new_count > 0 && (
                                        <div className="mt-1.5 inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-[0.16em] text-[var(--jr-success)]">
                                            <Sparkles size={9}/> {s.new_count} nieuw
                                        </div>
                                    )}
                                </button>
                                <div className="mt-2 pt-2 border-t border-white/8 flex items-center justify-between">
                                    <span className={`text-[10px] font-mono uppercase tracking-[0.16em] ${isActive ? "text-[var(--jr-amber)]" : "text-[var(--jr-text-3)]"}`}>
                                        {isActive ? i18n.t("search.active_check") : i18n.t("search.click_filter")}
                                    </span>
                                    <button onClick={(e) => { e.stopPropagation(); onDelete(s.id, s.label); }}
                                        data-testid={`saved-search-delete-${s.id}`}
                                        title={i18n.t("search.delete_search_title")}
                                        className="p-1 rounded text-[var(--jr-text-3)] hover:text-[var(--jr-error)] hover:bg-[var(--jr-error)]/10">
                                        <Trash2 size={11}/>
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
